import { render } from "./BannerHomeComponent.vue?vue&type=template&id=6e23246c"
import script from "./BannerHomeComponent.vue?vue&type=script&lang=js"
export * from "./BannerHomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__